import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button } from "@mui/material";
import { matchPath, useLocation, useNavigate } from "react-router";

import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";

interface BackButtonProps {
  defaultText: string;
  defaultPath: string;
}

function getLabelForPath(
  pathname: string,
  t: ReturnType<typeof useResource>["t"],
): string | null {
  if (matchPath(AppRouting.ProjectJobDetail.route, pathname))
    return t(Resources.Common.BackToProject);
  if (matchPath(AppRouting.ProjectDetail.route, pathname))
    return t(Resources.Common.BackToProject);
  if (matchPath(AppRouting.Projects.path(), pathname))
    return t(Resources.Common.BackToProjects);
  if (matchPath(AppRouting.ClientDetail.route, pathname))
    return t(Resources.Common.BackToClient);
  if (matchPath(AppRouting.Clients.path(), pathname))
    return t(Resources.Common.BackToClients);
  if (matchPath(AppRouting.ActorDetail.route, pathname))
    return t(Resources.Common.BackToActors);
  if (matchPath(AppRouting.Actors.path(), pathname))
    return t(Resources.Common.BackToActors);
  if (matchPath(AppRouting.PartnerDetail.route, pathname))
    return t(Resources.Common.BackToPartner);
  if (matchPath(AppRouting.Partners.path(), pathname))
    return t(Resources.Common.BackToPartners);
  if (matchPath(AppRouting.ModuleDetail.route, pathname))
    return t(Resources.Common.BackToModule);
  if (matchPath(AppRouting.Modules.path(), pathname))
    return t(Resources.Common.BackToModules);
  if (matchPath(AppRouting.PriceCategories.path(), pathname))
    return t(Resources.Common.BackToPriceCategories);
  if (matchPath(AppRouting.WithdrawalApprovals.path(), pathname))
    return t(Resources.Common.BackToWithdrawalApprovals);
  if (matchPath(AppRouting.RegistrationRequests.path(), pathname))
    return t(Resources.Common.BackToRegistrationRequests);
  if (matchPath(AppRouting.Dashboard.path(), pathname))
    return t(Resources.Common.BackToDashboard);
  return null;
}

export const BackButton = ({
  defaultText,
  defaultPath,
}: BackButtonProps): React.ReactNode => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useResource();

  const from = location.state?.from as { pathname: string } | undefined;
  const text = (from && getLabelForPath(from.pathname, t)) ?? defaultText;

  const handleClick = () => {
    if (from) {
      navigate(-1);
    } else {
      navigate(defaultPath);
    }
  };

  return (
    <Button
      variant="text"
      color="primary"
      startIcon={<ArrowBackIcon />}
      onClick={handleClick}
      sx={{ fontSize: "16px", textTransform: "none" }}
    >
      {text}
    </Button>
  );
};
